<template>
  <Modal
    :id="id"
    :no-close-on-backdrop="preventClose"
    @hidden="$emit('hidden')"
    @shown="$emit('shown')"
  >
    <div
      class="sm:px-[12px] py-[8px] sm:py-[20px] flex flex-col gap-[24px] items-center justify-center min-h-[256px]"
      :class="innerClass"
    >
      <span
        v-if="status === 'star'"
        class="text-[100px] leading-[100px]"
      >🌟</span>
      <img
        v-else
        :src="`https://storage.googleapis.com/komerce/assets/svg/Icon-${modalStatus}.svg`"
        alt="status"
        width="100"
        height="100"
      >
      <div class="w-full">
        <b class="block text-center mb-[16px] text-[20px] text-[#333333] font-semibold">{{ title }}</b>
        <p
          v-if="description"
          class="text-center mb-0 text-[14px] text-[#222222]"
        >
          {{ description }}
        </p>
        <slot />
      </div>
      <div
        v-if="cancelLabel || confirmLabel"
        class="w-full flex gap-x-[12px] gap-y-[8px]"
        :class="{ 'flex-col sm:flex-row': mobileVerticalAction }"
      >
        <b-button
          v-if="cancelLabel"
          variant="outline-primary"
          class="grow basis-[50%] whitespace-nowrap"
          @click="handleClose"
        >
          {{ cancelLabel }}
        </b-button>
        <b-button
          v-if="confirmLabel"
          :disabled="disabled || loading"
          variant="primary"
          class="grow basis-[50%] whitespace-nowrap"
          @click="$emit('onConfirm')"
        >
          <b-spinner
            v-if="loading"
            class="mr-[6px]"
            small
          />
          {{ confirmLabel }}
        </b-button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal.vue'

export default {
  components: { Modal },
  props: {
    id: {
      type: String,
      required: true,
    },
    preventClose: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'PIN Kamu Berhasil Dibuat',
    },
    status: {
      type: String,
      default: 'success',
    },
    description: {
      type: String,
      default: 'PIN dibuat untuk mengamankan transaksi kamu.',
    },
    cancelLabel: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: '',
    },
    mobileVerticalAction: {
      type: Boolean,
      default: false,
    },
    innerClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalStatus() {
      switch (this.status) {
        case 'warning': return 'Warning'
        case 'error': return 'Error'
        default: return 'Success'
      }
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.id)
      this.$emit('onClose')
    },
  },
}
</script>
